<template>
  <div class="personal-center-shell">
    <site-header
      :user-info="authReady ? userInfo : ''"
      :group-user-info="authReady ? groupUserInfo : ''"
      :group-user-infos="authReady ? groupUserInfos : []"
      :showlogin-out="authReady && showloginOut"
      :auth-loading="!authReady"
      :personal-menu="personalMenu"
      :active-personal-path="activePersonalPath"
      @auth="showIframe"
      @center="info"
      @logout="logOut"
      @personal-navigate="navigatePersonal"
    />

    <main class="personal-page">
      <div :class="['personal-layout', { 'personal-layout--mobile': isH5 }]">
        <aside v-if="!isH5" id="menu-div" aria-label="个人中心导航">
          <div class="personal-menu-title">
            <span>PERSONAL CENTER</span>
            <strong>个人中心</strong>
          </div>
          <el-menu :default-active="$route.path" router>
            <el-menu-item index="/account" data-track-text="个人中心账号设置">
              <img src="../assets/zhanghao.png" alt="" />
              <span>账号设置</span>
            </el-menu-item>
            <el-menu-item index="/meal" data-track-text="个人中心用户充值">
              <img src="../assets/vip.png" alt="" />
              <span>用户充值</span>
            </el-menu-item>
            <el-menu-item index="/order" data-track-text="个人中心发票申请">
              <img src="../assets/order.png" alt="" />
              <span>发票申请</span>
            </el-menu-item>
            <el-menu-item v-if="hasShow" index="/dictionary" data-track-text="个人中心定义字典">
              <img src="../assets/map.png" alt="" />
              <span>定义字典</span>
            </el-menu-item>
          </el-menu>
        </aside>

        <section id="main-div" :class="{ 'main-div--mobile': isH5 }">
          <router-view v-if="authReady" />
          <div v-else class="personal-loading" role="status" aria-live="polite">
            <span class="personal-loading-spinner" aria-hidden="true" />
            <span>正在加载个人中心</span>
          </div>
        </section>
      </div>
    </main>

    <site-footer />
  </div>
</template>

<script>
import {getTest} from '@/api/test'
import SiteHeader from '@/components/home/SiteHeader.vue'
import SiteFooter from '@/components/home/SiteFooter.vue'
import {isSmallScreen} from '@/utils/responsive'

export default {
  name: 'Index',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      hasShow: false,
      payCenterDialogVisible: false,
      groupUserInfos: [],
      url: '/login',
      activeIndex: '1',
      userInfo: '',
      iframeState: false,
      showloginOut: false,
      showHeader: true,
      groupUserInfo: '',
      userType: '',
      isH5: false,
      authReady: false,
    }
  },
  computed: {
    personalMenu() {
      const items = [
        {
          label: '账号设置',
          desc: '个人资料与账号安全',
          path: '/account',
          aliases: ['/rePass', '/rePhone', '/reEmail'],
          icon: 'el-icon-user'
        },
        {
          label: '用户充值',
          desc: '钱包余额与充值记录',
          path: '/meal',
          aliases: [],
          icon: 'el-icon-wallet'
        },
        {
          label: '发票申请',
          desc: '订单记录与发票管理',
          path: '/order',
          aliases: ['/orderDetail', '/billDetail', '/applyBill'],
          icon: 'el-icon-tickets'
        },
        {
          label: '定义字典',
          desc: '管理个人翻译术语',
          path: '/dictionary',
          aliases: [],
          icon: 'el-icon-notebook-2',
          requiresMap: true
        }
      ]
      return items.filter(item => !item.requiresMap || this.hasShow)
    },
    activePersonalPath() {
      const routePath = this.$route.path
      const activeItem = this.personalMenu.find(item => item.path === routePath || item.aliases.includes(routePath))
      return activeItem ? activeItem.path : '/account'
    }
  },
  created() {
    this.hasShowFun()
    const that = this;
    this.$http.post('/api/getUserInfo', {
      mealType: this.meal
    }).then(function (response) {
      if (!response.data) {
        if (that.enterLocalPreview()) {
          return
        }
        window.open(process.env.VUE_APP_INDEX, "_self")
        return
      }
      let hasPerson = false;
      response.data.forEach((item, index) => {
        if (hasPerson) {
          return
        }
        hasPerson = item.type === "Child" || item.type === "Person";
      })
      if (!hasPerson) {
        if (that.enterLocalPreview()) {
          return
        }
        window.open(process.env.VUE_APP_INDEX, "_self")
        return
      }
      localStorage.setItem("auth-context", JSON.stringify(response.data))
      that.getUserInfo()
      that.authReady = true
      that.$track('personal_center_auth_result', {result: 'success'})
    }).catch(function (error) {
      if (that.enterLocalPreview()) {
        that.$track('personal_center_auth_result', {result: 'preview'})
        return
      }
      that.$track('personal_center_auth_result', {result: 'failure', reason: 'request_failed'})
      window.open(process.env.VUE_APP_INDEX, "_self")
    });
    this.updateViewportMode()
  },
  mounted() {
    window.addEventListener('resize', this.updateViewportMode)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewportMode)
  },
  methods: {
    enterLocalPreview() {
      const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname)
      if (process.env.NODE_ENV !== 'development' || !isLocalHost) {
        return false
      }

      let authContext = []
      try {
        authContext = JSON.parse(localStorage.getItem('auth-context') || '[]')
      } catch (error) {
        authContext = []
      }

      const hasPersonalIdentity = Array.isArray(authContext) && authContext.some(item =>
        item && (item.type === 'Person' || item.type === 'Child')
      )

      if (!hasPersonalIdentity) {
        authContext = [
          {type: 'Person', name: '张好', realName: '', isRoaming: false},
          {type: 'Group', name: '清华大学', realName: ''}
        ]
        localStorage.setItem('auth-context', JSON.stringify(authContext))
      }

      this.getUserInfo()
      this.authReady = true
      return true
    },
    hasShowFun() {
      const that = this;
      this.$http.get('/api/hasMap').then(function (response) {
        that.hasShow = response.data
      }).catch(function (error) {
        that.hasShow = false
      });
    },
    isMobile() {
      return isSmallScreen()
    },
    updateViewportMode() {
      this.isH5 = this.isMobile()
    },
    setCookie(name, value, expiredays) {
      const exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie = name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
    },
    getUrlParameter(route) {
      //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
      let url = decodeURIComponent(route).split('?');
      url = url[url.length - 1];
      let obj = {};
      url.split('&&').map((query) => {
        let temp = query.split('=');
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    showIframe(url) {
      if (this.isMobile()) {
        const base = (process.env.VUE_APP_INDEX || 'https://wesitrans.com').replace(/\/$/, '')
        const path = url === '/register' ? '/h5/register' : '/h5/login'
        window.location.assign(`${base}${path}`)
        return
      }
      const newUrl = process.env.VUE_APP_LOGIN + url;
      this.$layer.open({
        area: ['948px', '501px'],
        type: 2,
        title: false,
        shadeClose: true,
        anim: -1,
        content: [newUrl, 'no'],
      });
    },
    logOut() {
      this.$track('logout_submit', {action: 'submit'})
      this.$http.get("/api/logOut").then(res => {
        if (res.data) {
          this.$track('logout_result', {result: 'success'})
          localStorage.removeItem("auth-context")
          this.setCookie('token', "", 2 * 1000 * 60 * 60);
          window.open(process.env.VUE_APP_INDEX || "https://wesitrans.com/", "_self");
        } else {
          this.$track('logout_result', {result: 'failure', reason: 'rejected'})
        }
      }).catch(err => {
        this.$track('logout_result', {result: 'failure', reason: 'request_failed'})
      })
    },
    getUserInfo() {
      localStorage.setItem("groupUser", "");
      localStorage.setItem("userType", "")
      this.userInfo = ''
      this.showloginOut = false
      this.groupUserInfos = []
      this.groupUserInfo = ''
      const user = localStorage.getItem('auth-context');
      if (!user) {
        return
      }
      const userJson = JSON.parse(user);
      const Base64 = require('js-base64').Base64;
      userJson.forEach(item => {
        if (item.type === 'Person' || item.type === 'Child') {
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          this.userInfo = realName
          if (this.groupUserInfo === '') {
            this.groupUserInfo = '机构登录';
          }
          this.showloginOut = true
          if (item.isRoaming) {
            this.userType = "2"
            localStorage.setItem("userType", "2");
          } else {
            if (item.type === 'Person') {
              this.userType = "0"
              localStorage.setItem("userType", "0");
            } else {
              this.userType = "1"
              localStorage.setItem("userType", "1");
            }
          }
        }
        if (item.type === 'Group') {
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          this.groupUserInfos.push({
            ...item,
            displayName: realName
          })
          localStorage.setItem("groupUser", realName);
          this.groupUserInfo = realName;
          this.url = process.env.VUE_APP_WEB_LOGIN_URL;
        }
      });
    },
    meal() {
      this.$router.push('/meal')
    },
    info() {
      this.$router.push('/account')
    },
    order() {
      this.$router.push('/order')
    },
    dictionary() {
      this.$router.push('/dictionary')
    },
    navigatePersonal(path) {
      if (path && this.$route.path !== path) {
        this.$track('personal_navigation', {target: path})
        this.$router.push(path)
      }
    },
    clickHanler(url) {
      if (url === '/translate-pro') {
        window.open('https://pro.wesitrans.com/index', "_self");
        return
      }
      let newUrl = process.env.VUE_APP_INDEX + url
      window.open(newUrl, "_self");
    },
    test() {
      getTest().then(testResponse => {
        alert(testResponse.data)
      })
    }
  }
}
</script>

<style scoped>
.personal-center-shell {
  --primary: #063f95;
  --accent: #0c7dba;
  width: 100%;
  min-width: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: #1a1a2e;
  background: #f3f7f9;
}

.personal-page {
  width: 100%;
  min-width: 0;
  flex: 1 0 auto;
  padding: 24px;
}

.personal-layout {
  width: 100%;
  min-width: 0;
  max-width: 1216px;
  min-height: calc(100vh - 176px);
  margin: 0 auto;
  display: flex;
  align-items: stretch;
  gap: 20px;
}

#menu-div {
  flex: 0 0 286px;
  width: 286px;
  overflow: hidden;
  border: 1px solid #e3eceb;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(62, 109, 119, .08);
}

.personal-menu-title {
  height: 118px;
  padding: 26px 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  color: #fff;
  background: linear-gradient(135deg, #063f95, #0c7dba);
}

.personal-menu-title span {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2.5px;
  opacity: .78;
}

.personal-menu-title strong {
  font-size: 24px;
  line-height: 1;
}

#menu-div /deep/ .el-menu {
  padding: 12px 0;
  border-right: 0;
  background: transparent;
}

#menu-div /deep/ .el-menu-item {
  height: 54px;
  margin: 4px 14px;
  padding: 0 18px !important;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #606b75;
  font-size: 15px;
  line-height: 54px;
  border-radius: 10px;
  transition: color .18s ease, background-color .18s ease;
}

#menu-div /deep/ .el-menu-item:hover {
  color: var(--primary);
  background: #f5f9fd;
}

#menu-div /deep/ .el-menu-item.is-active {
  padding-left: 14px !important;
  color: var(--primary);
  font-weight: 600;
  border-left: 4px solid var(--accent);
  background: #eef7fd;
}

#menu-div /deep/ .el-menu-item img {
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  object-fit: contain;
}

#main-div {
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100%;
  padding: 20px 0 20px 20px;
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(62, 109, 119, .08);
}

.personal-loading {
  min-height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #78828d;
  font-size: 14px;
}

.personal-loading-spinner {
  width: 34px;
  height: 34px;
  border: 3px solid #d9e6f4;
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: personal-loading-spin .8s linear infinite;
}

@keyframes personal-loading-spin {
  to { transform: rotate(360deg); }
}

.personal-layout--mobile {
  max-width: none;
  min-height: 0;
  display: block;
}

.main-div--mobile {
  padding: 0 !important;
  overflow-x: hidden !important;
  overflow-y: visible !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: #f5f8fa !important;
  box-shadow: none !important;
}

@media (max-width: 768px) {
  .personal-center-shell {
    max-width: 100%;
    overflow-x: hidden;
  }

  .personal-page {
    max-width: 100%;
    min-height: calc(100vh - var(--mobile-header-height, 56px));
    min-height: calc(100dvh - var(--mobile-header-height, 56px));
    padding: 0;
    overflow-x: hidden;
  }

  .personal-layout {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 0;
    display: block;
    overflow-x: hidden;
  }

  #menu-div {
    display: none;
  }

  #main-div {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 0;
    overflow-x: hidden;
    overflow-y: visible;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }

  .personal-center-shell /deep/ .site-footer-shell {
    padding-bottom: calc(var(--mobile-bottom-height, 58px) + env(safe-area-inset-bottom));
    background: #19192b;
  }
}
</style>
